import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';

@Component({
  selector: 'svc-customer-signature-dialog',
  templateUrl: './customer-signature-dialog.component.html',
  styleUrls: ['./customer-signature-dialog.component.scss'],
})
export class CustomerSignatureDialogComponent implements OnInit {
  signaturePadOptions: { canvasWidth: number; canvasHeight: number; backgroundColor: string } = {
    // passed through to szimek/signature_pad constructor
    canvasWidth: 100,
    canvasHeight: 180,
    backgroundColor: 'rgba(255, 255, 255, 0)',
  };
  @ViewChild('sigPad') signaturePad: SignaturePadComponent;
  displayClearSignature = false;
  signature: string;
  uncroppedSignature: string;

  constructor(
    public dialogRef: MatDialogRef<CustomerSignatureDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      agreementClause: string;
      savedSignature: string;
      savedUncroppedSignature: string;
    }
  ) {}

  ngOnInit(): void {
    this.signaturePadOptions.canvasWidth = document.getElementById('signature-container').offsetWidth - 2;

    if (this.dialogData.savedSignature) {
      this.displayClearSignature = true;
      this.signature = this.dialogData.savedSignature;
      this.uncroppedSignature = this.dialogData.savedUncroppedSignature;
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

  save(signature: string, uncroppedSignature: string) {
    this.dialogRef.close({ signature: signature, uncroppedSignature: uncroppedSignature });
  }

  onResize(event: Event) {
    this.signaturePad.resizeCanvas(document.getElementById('signature-container').offsetWidth - 2);
    this.signaturePad.drawImageScaled(this.uncroppedSignature);
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    this.signature = this.signaturePad.removeBlanks();
    this.uncroppedSignature = this.signature ? this.signaturePad.toDataURL() : null;
    this.displayClearSignature = this.signature ? true : false;
  }

  clearSignature() {
    this.signaturePad.clear();
    this.displayClearSignature = false;
    this.signature = '';
    this.uncroppedSignature = '';
  }
}
